import React, {useEffect, useState} from "react";
import {useHistory} from "react-router";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField/TextField";
import "./anniv2026.css";
import {Login2026} from "./Login2026";
import {errorMessage, post} from "./api2026";

export const AdminAnniv2026Page = () => {

    const history = useHistory();
    const [player, setPlayer] = useState(undefined);

    return (
        <Box className="board-game anniv2026" sx={{width: {xs: "95%", md: "80%"}}}>
            <h2 className="anniv2026-title">Admin · Concours 2026</h2>
            <div style={{marginBottom: "2vh"}}>
                <Button size="small" onClick={() => history.push("/anniv/2026")}>← Retour au vote</Button>
            </div>
            {
                !player ?
                    <Login2026 setPlayer={setPlayer}/> :
                    !player.admin ?
                        <div>Page réservée à l'admin.</div> :
                        <div>
                            <NostraSection/>
                            <GamesSection/>
                            <PlayersSection/>
                            <ResultsSection/>
                        </div>
            }
        </Box>
    );
}

const NostraSection = () => {

    const [info, setInfo] = useState(undefined);
    const [message, setMessage] = useState("");
    const [debug, setDebug] = useState(undefined);
    const [syncing, setSyncing] = useState(false);

    useEffect(() => load(), []);

    function load() {
        post("/admin/nostra").then(setInfo).catch(err => setMessage(errorMessage(err)));
    }

    function sync() {
        setSyncing(true);
        setMessage("");
        post("/admin/nostra/sync").then(data => {
            setMessage(data.fetched + " sessions lues sur Nostra");
            setDebug(data.debug);
            load();
        }).catch(err => setMessage(errorMessage(err))).finally(() => setSyncing(false));
    }

    return (
        <div className="anniv2026-admin-section">
            <h3>Sessions Nostra {info ? "(" + info.sessions + " en cache)" : ""}</h3>
            {info && !info.configured ? <p style={{color: "#EA1F70"}}>NOSTRA_ADMIN_IDENTIFIER / NOSTRA_ADMIN_PASSWORD ne sont pas configurés sur le serveur.</p> : undefined}
            {
                info ?
                    <div className="anniv2026-admin-row">
                        Parties comptées du {new Date(info.window.start).toLocaleString()} au {new Date(info.window.end).toLocaleString()}
                    </div> :
                    undefined
            }
            <div className="anniv2026-admin-row">
                <Button variant="contained" disabled={syncing} onClick={sync}>
                    {syncing ? "Synchronisation..." : "Synchroniser maintenant"}
                </Button>
                <Button variant="contained" color="secondary" onClick={() => window.open("/anniv/2026/leaderboard", "_blank")}>
                    Leaderboard
                </Button>
            </div>
            {info && info.syncError ? <p style={{color: "#EA1F70"}}>Dernière synchro en échec ({new Date(info.syncError.at).toLocaleTimeString()}) : {info.syncError.message}</p> : undefined}
            {info && info.lastSync ? <div style={{fontSize: "0.85em", opacity: 0.7}}>Dernière synchro : {new Date(info.lastSync).toLocaleString()}</div> : undefined}
            {message ? <p>{message}</p> : undefined}
            {
                debug ?
                    <details>
                        <summary>Diagnostic de la première session lue</summary>
                        <pre style={{whiteSpace: "pre-wrap", fontSize: "0.75em"}}>{JSON.stringify(debug, null, 2)}</pre>
                    </details> :
                    undefined
            }
        </div>
    );
}

const GamesSection = () => {

    const [sectionTitle, setSectionTitle] = useState("");
    const [games, setGames] = useState([]);
    const [lastSync, setLastSync] = useState(undefined);
    const [message, setMessage] = useState("");
    const [syncing, setSyncing] = useState(false);

    useEffect(() => load(), []);

    function load() {
        post("/admin/games").then(data => {
            setGames(data.games);
            setLastSync(data.lastSync);
            setSectionTitle(title => title || data.sectionTitle || "");
        }).catch(err => setMessage(errorMessage(err)));
    }

    function sync() {
        setSyncing(true);
        setMessage("");
        post("/admin/sync", {sectionTitle}).then(data => {
            setMessage(data.count + " jeux synchronisés depuis « " + data.sectionTitle + " »");
            load();
        }).catch(err => {
            const sections = err.response && err.response.data && err.response.data.availableSections;
            setMessage(errorMessage(err) + (sections ? " — catégories disponibles : " + sections.join(", ") : ""));
        }).finally(() => setSyncing(false));
    }

    const visibleGames = games.filter(game => !game.hidden);
    const hiddenGames = games.filter(game => game.hidden);

    return (
        <div className="anniv2026-admin-section">
            <h3>Jeux ({visibleGames.length})</h3>
            <div className="anniv2026-admin-row">
                <TextField
                    size="small"
                    placeholder="Titre de la catégorie Nostra"
                    value={sectionTitle}
                    onChange={(e) => setSectionTitle(e.target.value)}
                    style={{flex: 1, minWidth: "200px"}}
                />
                <Button variant="contained" disabled={!sectionTitle || syncing} onClick={sync}>
                    {syncing ? "Synchronisation..." : "Synchroniser depuis Nostra"}
                </Button>
            </div>
            {lastSync ? <div style={{fontSize: "0.85em", opacity: 0.7}}>Dernière synchro : {new Date(lastSync).toLocaleString()}</div> : undefined}
            {message ? <p>{message}</p> : undefined}
            <table className="anniv2026-table">
                <tbody>
                {
                    [...visibleGames, ...hiddenGames].map(game =>
                        <tr key={game.id} style={game.hidden ? {opacity: 0.4} : {}}>
                            <td><img src={game.logo} alt=""/></td>
                            <td>
                                <a href={game.href} target="_blank" rel="noreferrer">{game.name}</a>
                                {game.hidden ? " (retiré)" : ""}
                            </td>
                            <td>
                                {
                                    game.authors.map(author =>
                                        <span key={author} className={"anniv2026-author " + (author.known ? "known" : "unknown")}
                                              title={author.known ? "Joueur trouvé" : "Aucun joueur avec ce nom"}>
                                            {author.key}
                                        </span>
                                    )
                                }
                            </td>
                        </tr>
                    )
                }
                </tbody>
            </table>
            <p style={{fontSize: "0.85em", opacity: 0.7}}>
                Auteur en rouge : aucun joueur ne porte ce nom, il pourra voter pour son propre jeu.
            </p>
        </div>
    );
}

const PlayersSection = () => {

    const [players, setPlayers] = useState([]);
    const [newUsername, setNewUsername] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [message, setMessage] = useState("");

    useEffect(() => load(), []);

    function load() {
        post("/admin/players").then(data => setPlayers(data.players)).catch(err => setMessage(errorMessage(err)));
    }

    function addPlayer() {
        setMessage("");
        post("/admin/players/add", {newUsername, newPassword}).then(() => {
            setNewUsername("");
            setNewPassword("");
            load();
        }).catch(err => setMessage(errorMessage(err)));
    }

    function deletePlayer(player) {
        if (!window.confirm("Supprimer " + player.username + " et son vote ?")) {
            return;
        }
        post("/admin/players/delete", {key: player.key}).then(load).catch(err => setMessage(errorMessage(err)));
    }

    return (
        <div className="anniv2026-admin-section">
            <h3>Joueurs ({players.length} · {players.filter(p => p.voted).length} ont voté)</h3>
            <form className="anniv2026-admin-row" onSubmit={(e) => {
                e.preventDefault();
                addPlayer();
            }}>
                <TextField size="small" placeholder="Nom" value={newUsername} onChange={(e) => setNewUsername(e.target.value)}/>
                <TextField size="small" placeholder="Mot de passe" value={newPassword} onChange={(e) => setNewPassword(e.target.value)}/>
                <Button variant="contained" type="submit" disabled={!newUsername || !newPassword}>Ajouter</Button>
            </form>
            {message ? <p>{message}</p> : undefined}
            <table className="anniv2026-table">
                <thead>
                <tr><th>Nom</th><th>Mot de passe</th><th>A voté</th><th/></tr>
                </thead>
                <tbody>
                {
                    players.map(player =>
                        <tr key={player.key}>
                            <td>{player.username}</td>
                            <td>{player.password}</td>
                            <td>{player.voted ? "✓" : ""}</td>
                            <td>
                                <Button size="small" color="error" onClick={() => deletePlayer(player)}>Supprimer</Button>
                            </td>
                        </tr>
                    )
                }
                </tbody>
            </table>
        </div>
    );
}

const ResultsSection = () => {

    const [results, setResults] = useState(undefined);
    const [message, setMessage] = useState("");

    useEffect(() => load(), []);

    function load() {
        post("/admin/results").then(setResults).catch(err => setMessage(errorMessage(err)));
    }

    return (
        <div className="anniv2026-admin-section">
            <div className="anniv2026-admin-row" style={{justifyContent: "space-between"}}>
                <h3 style={{margin: 0}}>Résultats {results ? "(" + results.voters + " votants)" : ""}</h3>
                <span>
                    <Button variant="contained" color="secondary" onClick={() => window.open("/anniv/2026/reveal", "_blank")}>
                        Reveal des résultats
                    </Button>
                    {" "}
                    <Button variant="contained" onClick={load}>Rafraîchir</Button>
                </span>
            </div>
            {message ? <p>{message}</p> : undefined}
            {
                results ? results.results.map(category =>
                    <div key={category.id} style={{marginTop: "2vh"}}>
                        <h4>{category.label} <span style={{fontSize: "0.8em", opacity: 0.7}}>({category.ballots} bulletins)</span></h4>
                        {
                            category.ranking.length === 0 ?
                                <div style={{opacity: 0.6}}>Aucun vote</div> :
                                <table className="anniv2026-table">
                                    <thead>
                                    <tr><th>#</th><th/><th>Jeu</th><th>Points</th><th>1er</th><th>2e</th><th>3e</th></tr>
                                    </thead>
                                    <tbody>
                                    {
                                        category.ranking.map((game, index) =>
                                            <tr key={game.id}>
                                                <td>{index + 1}</td>
                                                <td><img src={game.logo} alt=""/></td>
                                                <td>{game.name} <span style={{opacity: 0.6}}>· {game.authorName}</span></td>
                                                <td><b>{game.points}</b></td>
                                                <td>{game.ranks[0]}</td>
                                                <td>{game.ranks[1]}</td>
                                                <td>{game.ranks[2]}</td>
                                            </tr>
                                        )
                                    }
                                    </tbody>
                                </table>
                        }
                    </div>
                ) : undefined
            }
        </div>
    );
}
